import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { ISupplierProductDocument } from '~/types/document/models'

export const {
  getDocumentListData: getSupplierProductDocumentListData,
  getDocumentDataById: getSupplierProductDocumentDataById,
  getDocumentListDataByParentId:
    getSupplierProductDocumentListDataBySupplierProductId,
} = makeDocumentMockData<ISupplierProductDocument>({
  entityName: 'supplierProduct',
  storageKeyPrefix: 'supplierProduct',
})
